/**
 * Manages and animates the digistudio toolbars.
 */

define('libs/digistudio.toolbar',[],function() {

    'use strict';

    var SETTINGS = {
            toggleSelector: '.btn-toggle',
            dialogSelector: '.toolbar-dialog',
            classToggle: 'actions-bar',
            menuSelectLinkSelector: '.menu-select-btn'
        };


    var Toolbar = function(root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.root = root;

        // initialize the toggle buttons.
        this.root.on('click', this.settings.toggleSelector, this.toggle.bind(this));

        // initialize the menu buttons that open the dialogs.
        this.root.on('click', this.settings.menuSelectLinkSelector, this.onMenuButtonClick.bind(this));
    };

    /**
     * Add the toggle class for the css animation.
     */
    Toolbar.prototype.toggle = function(event) {
        event.preventDefault();

        // close any open dialogs.
        this.root.trigger('dialog.close');

        this.root.toggleClass(this.settings.classToggle);
    };

    Toolbar.prototype.onMenuButtonClick = function(event) {
        event.preventDefault();
        var dialog = $('#' + event.currentTarget.getAttribute('data-dialog'));
        if (dialog.length) {
            this.root.trigger('dialog.close');

            dialog.fadeIn(300, function() {
                var closeFunc = function(dialog, event) {
                    if ($(event.target).is(this.settings.dialogSelector) || !$(event.target).closest(this.settings.dialogSelector).length) {
                        this.closeDialog(dialog);
                    }
                }.bind(this, dialog);

                dialog.data('closeFunc', closeFunc);
                $(document).on('click', closeFunc);
            }.bind(this));
        }
        if (!dialog.data('hasCloser')) {
            var closer = this.closeDialog.bind(this, dialog);
            this.root.on('dialog.close', closer);
            dialog.on('click', 'a', closer);
            dialog.data('hasCloser', true);
        }
    };

    Toolbar.prototype.closeDialog = function(dialog, event) {
        if (event) {
            event.preventDefault();
        }
        dialog.fadeOut(300);
        if (dialog.data('closeFunc')) {
            $(document).off('click', dialog.data('closeFunc'));
            dialog.data('closeFunc', null);
        }
    };


    return Toolbar;
});

